import { defineMessages } from 'react-intl-next';
export default defineMessages({
  hubLogo: {
    id: 'hub-app-shell.navbar.hub.logo.non-final',
    defaultMessage: 'Hub logo',
    description: 'The logo of the Hub'
  },
  login: {
    id: 'hub-app-shell.navbar.hub.log-in.non-final',
    defaultMessage: 'Log in',
    description: 'Log in button label'
  }
});